export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ../~/d3-chord/src/array.js
// module id = +jHx
// module chunks = 0